import { useState } from 'react';
import { Modal } from '../Modal';

export interface ImageBlockProps {
  src: string;
}

export function ImageBlock(props: ImageBlockProps) {
  const { src } = props;
  const [show, setShow] = useState(false);

  return (
    <>
      <div
        onClick={() => setShow(true)}
        className="cursor-pointer group block w-full object-cover aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden"
      >
        <img
          src={src}
          alt=""
          className="w-full h-full pointer-events-none group-hover:opacity-75"
        />
      </div>
      <Modal show={show} onClose={() => setShow(false)}>
        <div className="object-cover inline-block align-bottom aspect-w-10 aspect-h-7 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle">
          <img
            className="h-full"
            alt="block"
            src={src
              .split('/')
              .splice(0, src.split('/').length - 1)
              .concat('qhd')
              .join('/')}
          />
        </div>
      </Modal>
    </>
  );
}

export default ImageBlock;
